<template>
  <section class="scene-shop-app">
    <div class="scene-shop-app__padding">
      <div class="scene-shop-app__stage">
        <section class="page-area noselect">
          <p class="page__title"><strong>How to Build a Set</strong></p>

          <!-- Getting Started -->
          <div class="page page--0" v-if="currentPage === 0">

            <div class="floor_plan"></div>

            <div class="page__instructions">
              <p class="page__sub_title">getting started</p>
              <p>The scenery, or set, helps create the illusion of a particular time and place in a play. The set
                dsigner reads the play and makes drawings of the set for each scene.</p>
            </div>
          </div>

          <!-- 1. Sketch -->
          <div class="page page--1" v-if="currentPage === 1">

          <div class="s1wrap">
            <Container group-name="dndPencilDrop" @drop="dndPencilDrop" :should-animate-drop="()=>false">
              <Scene1Animation ref="scene1animation"></Scene1Animation>
              <div class="floor_plan2" v-show="!hasPencilToolBeenUsed"></div>
            </Container>
          </div>

            <div class="tool-box-scene2" style="display: flex;">
              <div class="tool-box-scene2__area-twin__left">
                <Container group-name="dndPencilDrop" :drag-begin-delay="0">
                  <Draggable v-if="!hasPencilToolBeenUsed">
                    <div class="pencil"></div>
                  </Draggable>
                </Container>
              </div>
            </div>

            <div class="page__instructions_sketch">
              <p class="page__sub_title">sketch</p>
              <p>Drag and release the pencil to create a sketch of the set for bridal shop scene in West Side Story, a
                modern-day version of Shakespeare's Romeo and Juliet that takes places in the late 1950's in New York
                City.</p>
            </div>
          </div>

          <!-- 2. Scale Model -->
          <div class="page page--2" v-if="currentPage === 2">
            <div class="s2wrap">
              <div class="item" id="top">
                <Container group-name="dndWallBackDrop" @drop="dndWallBackDrop" :should-animate-drop="()=>false">
                  <div class="hide_wallBackDrop " v-if="!hasWallBackDropBeenUsed"></div>
                  <div class="show_wallBackDrop " v-if="hasWallBackDropBeenUsed"></div>
                </Container>
              </div>

              <div class="item" id="bottom">
                <Container group-name="dndShopWall" @drop="dndShopWall" :should-animate-drop="()=>false">
                  <div class="hide_shop" v-if="!hasShopWallBeenUsed"></div>
                  <div class="show_shop" v-if="hasShopWallBeenUsed"></div>
                </Container>
              </div>
            </div>


            <div class="woman"></div>
            <div class="base"></div>

            <div class="page__instructions_scale">
              <p class="page__sub_title">Scale Model</p>
              <p>The designer creates a scale model of the set based on the sketches, using balsa wood and cardboard.
                Click and drag the model walls over to the stage. Drag the table and chairs around the stage to see how
                they look in different positions.</p>

              <div class="toolbox toolbox--no-flex">
                <div class="toolbox__area">
                  <div class="toolbox__items toolbox__items--wall">
                    <Container group-name="dndWallBackDrop" :drag-begin-delay="0" :get-child-payload="()=> 'wall'">
                      <Draggable v-show="!hasWallBackDropBeenUsed">
                        <div class="tool tool--wall_backdrop"
                          @mouseenter="$event.currentTarget.classList.add('clicked')"
                          @mouseleave="$event.currentTarget.classList.remove('clicked')"
                          @touchstart="$event.currentTarget.classList.add('clicked')"
                          @touchend="$event.currentTarget.classList.remove('clicked')">
                        </div>
                        <div class="tool__text-backdrop">Wall Backdrop</div>
                      </Draggable>
                    </Container>
                  </div>

                  <div class="toolbox__items toolbox__items--shop-wall">
                    <Container group-name="dndWallBackDrop" :drag-begin-delay="0" :get-child-payload="()=> 'shop-wall'">
                      <Draggable v-show="!hasShopWallBeenUsed">
                        <div class="tool tool--shop_walls" @mouseenter="$event.currentTarget.classList.add('clicked')"
                          @mouseleave="$event.currentTarget.classList.remove('clicked')"
                          @touchstart="$event.currentTarget.classList.add('clicked')"
                          @touchend="$event.currentTarget.classList.remove('clicked')">
                        </div>
                        <div class="tool__text-walls">Shop Walls</div>
                      </Draggable>
                    </Container>
                  </div>

                  <div class="toolbox__items toolbox__items--table">
                    <vue-draggable-resizable>
                      <div class="tool tool--table" @mouseenter="$event.currentTarget.classList.add('clicked')"
                        @mouseleave="$event.currentTarget.classList.remove('clicked')"
                        @touchstart="$event.currentTarget.classList.add('clicked')"
                        @touchend="$event.currentTarget.classList.remove('clicked')">
                      </div>
                      <div class="tool__text-table">Table</div>
                    </vue-draggable-resizable>
                  </div>

                  <div class="toolbox__items toolbox__items--chair">
                    <vue-draggable-resizable>
                      <div class="tool tool--chair" @mouseenter="$event.currentTarget.classList.add('clicked')"
                        @mouseleave="$event.currentTarget.classList.remove('clicked')"
                        @touchstart="$event.currentTarget.classList.add('clicked')"
                        @touchend="$event.currentTarget.classList.remove('clicked')">
                      </div>
                      <div class="tool__text-chair">Chair</div>
                    </vue-draggable-resizable>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 3. Backdrop -->
          <div class="page page--3" v-show="currentPage === 3">

            <div class="background1" :class="{
              'switch-1-active':switch1Active,
            }"></div>

            <div class="background2" :class="{
              'switch-2-active':switch2Active,
            }"></div>

            <div class="background3" :class="{
              'switch-3-active':switch3Active,
            }"></div>

            <div class="curtain"></div>

            <div class="page__instructions">
              <p class="page__sub_title">Backdrop</p>
              <p>Carpenters and painters now build the full-size set. Sometimes the back wall is a painted curtain called
                a backdrop. Several backdrops can be stored in the fly loft, out of view of the audience until they are
                needed. When the scene changes cables lower the backdrop onto the stage. Click the switches until you
                get the brick wall backdrop.</p>
              <div class="tool-box">
                <div class="tool-box__area-double" style="display: flex;" :class="{
                  'switch-1-active':switch1Active,
                  'switch-2-active':switch2Active,
                  'switch-3-active':switch3Active,
                }">

                  <div class="tool-box__area-double__left-double">
                    <div class="tool-box__area-double__left-double switch1" @click="switchClick(1)"
                      @touchstart="switchClick(1)">
                    </div>
                  </div>

                  <div class="tool-box__area-double__middle-double">
                    <div class="tool-box__area-double__middle-double switch2" id="pointer2" @click="switchClick(2)"
                      @touchstart="switchClick(2)">
                    </div>
                  </div>

                  <div class="tool-box__area-double__right-double">
                    <div class="tool-box__area-double__right-double switch3" id="pointer3" @click="switchClick(3)"
                      @touchstart="switchClick(3)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 4. Flats -->
          <div class="page page--4" v-if="currentPage === 4">
            <div class="s4wrap">
              <div class="item">
                <Container group-name="dndBackDrop" @drop="dndBackDrop" :should-animate-drop="()=>false">
                  <div class="hide_curtain2" v-if="!hasBackDropBeenUsed"></div>
                  <div class="show_curtain2" v-if="hasBackDropBeenUsed"></div>
                </Container>
              </div>
            </div>

            <div class="curtain2"></div>

            <div class="page__instructions_flats">
              <p class="page__sub_title">Flats</p>
              <p>The other set walls, called flats, are made of painted canvas stretched over a wooden frame. Wing flats
                stand on either side of the stage, tilted at a slight angle towards the audience so that actors can hide
                behind them before making an entrance. Drag the bridal shop flats onto the stage.

                <div class="tool-box-scene4" style="display: flex;">
                  <div class="tool-box-scene4__area-twin__left">
                    <Container group-name="dndBackDrop" :drag-begin-delay="0">
                      <Draggable v-if="!hasBackDropBeenUsed">
                        <div class="tool tool--backdrop" @mouseenter="$event.currentTarget.classList.add('clicked')"
                          @mouseleave="$event.currentTarget.classList.remove('clicked')"
                          @touchstart="$event.currentTarget.classList.add('clicked')"
                          @touchend="$event.currentTarget.classList.remove('clicked')">
                        </div>
                        <div class="tool__text-backdrop2">Wall Backdrop</div>
                      </Draggable>
                    </Container>
                  </div>
                </div>
            </div>
          </div>

          <!-- 5. Props -->
          <div class="page page--5" v-show="currentPage === 5">
            <div class="tool-box-scene5" style="display: flex;">

              <div class="tool-box-scene5__area__left">
                <div class="tool tool--view_sketch" @mouseenter="$event.currentTarget.classList.add('hover')"
                  @mouseleave="$event.currentTarget.classList.remove('hover')"
                  @touchstart="$event.currentTarget.classList.add('hover')"
                  @touchend="$event.currentTarget.classList.remove('hover')">
                </div>
                <div class="hover_bg"></div>
              </div>

              <div class="tool-box-scene5__area__right">
                <a href="https://www.knowitall.org/series/stage">
                  <div class="tool tool--stage_button"></div>
                </a>
              </div>
            </div>

            <div class="curtain3"></div>

            <div class="page__instructions">
              <div class="hover_bg">
                <div class="hover_img"></div>
              </div>
              <p class="page__sub_title">Props</p>
              <p>Just like an actor, a set has to get "dressed." Drag the furniture, curtains and props to the stage
                to
                dress the set. Refer to the sketch if you need help. Now the stage is ready for the play to begin. On
                with the show!</p>
              <div class="tool-box-scene5-props" style="display: flex;">
                <div class="tool-box-scene5-props__area" style="display: flex;">
                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--curtain_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--woman_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--shelf_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--wig_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--table_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--wallcurtains_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--chair_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--dress_c"></div>
                  </vue-draggable-resizable>

                  <vue-draggable-resizable @dragging="onDragging" @dragstop="onDragStop">
                    <div class="tool tool--man_c"></div>
                  </vue-draggable-resizable>
                </div>
              </div>
            </div>
          </div>

          <div class="scene-shop-app__nav">
            <button v-show="currentPage > 0 && currentPage !== 5" @click="prevPage"
              class="i-btn i-btn--back">Back</button>
            <button v-if="currentPage < 5" @click="nextPage" class="i-btn i-btn--next">Next</button>

          </div>
        </section>
      </div>
    </div>
  </section>
</template>


<script>
  import {
    Howl
  } from 'howler'

  import {
    Container,
    Draggable
  } from 'vue-smooth-dnd';

  // import Moveable from "moveable";
  // import DragItDude from 'vue-drag-it-dude';

  import Scene1Animation from '@/components/scene1animation.vue'

  export default {
    name: 'app',
    components: {
      Container,
      Draggable,
      Scene1Animation,
      // DragItDude,
    },
    data: function () {
      return {
        switch1Active: false,
        switch2Active: false,
        switch3Active: false,
        isDragging: false,
        hasWallBackDropBeenUsed: false,
        hasShopWallBeenUsed: false,
        hasPencilToolBeenUsed: false,
        hasBackDropBeenUsed: false,
        currentPage: 0,
        currentSoundId: null,
        audio: new Howl({
          src: ['audio/scene-sounds.mp3'],
          sprite: {
            click: [117, 69],
          }
        }),
      }
    },

    mounted() {},
    computed: {},
    methods: {
      nextPage() {
        const pageBeforeLeaving = this.currentPage;
        if (this.currentPage < 5) {
          this.audio.play('click');
          this.currentPage++;
          this.resetTools(pageBeforeLeaving);
        }
      },
      prevPage() {
        const pageBeforeLeaving = this.currentPage;
        if (this.currentPage > 0) {
          this.audio.play('click');
          this.currentPage--;
          this.resetTools(pageBeforeLeaving);
        }
      },
      resetTools() {
        this.switch1Active = false,
          this.switch2Active = false,
          this.switch3Active = false,
          this.hasWallBackDropBeenUsed = false;
        this.hasShopWallBeenUsed = false;
        this.hasPencilToolBeenUsed = false;
        this.hasBackDropBeenUsed = false;
      },
      onDragging() {
        if (!this.isDragging) {
          this.isDragging = true;
        }
      },
      onDragStop() {
        if (this.isDragging) {
          this.isDragging = false;
        }
      },
      drawPattern(x, y, topCtx, bottomCtx, patternCanvas) {
        if (this.isDragging) {
          topCtx.fillStyle = bottomCtx.createPattern(patternCanvas, 'no-repeat');
          topCtx.beginPath();
          topCtx.arc(x, y, ((15 * window.innerWidth) / 725), 0, Math.PI * 2, true);
          topCtx.fill();
        }
      },

      switchClick(id) {
        if (id === 1) {
          this.switch1Active = true;
          document.getElementById("pointer2").style.cursor = "pointer"; 
        }
        if (id === 2 && this.switch1Active) {
          this.switch2Active = true;
          document.getElementById("pointer2").style.cursor = "default"; 
          document.getElementById("pointer3").style.cursor = "pointer";         

        }
        if (id === 3 && this.switch1Active && this.switch2Active) {
          this.switch3Active = true;
          document.getElementById("pointer3").style.cursor = "default"; 
        }
      },

      setupMouse(settings) {
        let {
          topCanvas,
          bottomCanvas,
          patternCanvas,
          onMouseMove,
          preventDefault,
          tool,
        } = settings;

        let mouse = {
          x: 0,
          y: 0,
          down: false
        };

        let rectLeft, rectTop;
        const bottomCtx = bottomCanvas.getContext('2d');
        const topCtx = topCanvas.getContext('2d');
        const hook = topCanvas.addEventListener.bind(topCanvas);
        const mouseDown = updateMouseStatus.bind(null, true);
        const mouseUp = updateMouseStatus.bind(null, false);
        const toolHook = tool.addEventListener.bind(tool);

        toolHook('touchmove', updateCoordinates);
        hook('mousedown', mouseDown);
        hook('mouseup', mouseUp);
        hook('mousemove', updateCoordinates);
        hook('scroll', updateRect);

        function updateMouseStatus(b, e) {
          mouse.down = b;
          updateCoordinates(e);
          if (preventDefault) {
            e.stopPropagation();
            e.preventDefault();
          }
        }

        function updateCoordinates(e) {
          if (e.type === 'touchmove') {
            mouse.x = (Math.floor(e.touches[0].clientX) - rectLeft);
            mouse.y = (Math.floor(e.touches[0].clientY) - rectTop);
          } else {
            mouse.x = (e.clientX - rectLeft);
            mouse.y = (e.clientY - rectTop);
          }

          onMouseMove(mouse.x, mouse.y, topCtx, bottomCtx, patternCanvas);
          updateRect();
        }

        function updateRect() {
          const cWidth = topCanvas.clientWidth;
          const cHeight = topCanvas.clientHeight;

          if (topCanvas.width !== cWidth || topCanvas.height !== cHeight) {
            topCanvas.width = cWidth;
            topCanvas.height = cHeight;
          }

          const rect = topCanvas.getBoundingClientRect();
          rectLeft = Math.floor(rect.left);
          rectTop = Math.floor(rect.top);
        }

        updateRect();
      },

      animateScene1() {
        this.$refs.scene1animation.animate();
      },

      dndWallBackDrop(dropResult) {
        // console.dir(dropResult);
        const {
          payload
        } = dropResult;

        if (payload === 'shop-wall') {
          this.hasShopWallBeenUsed = true;
        }

        if (payload === 'wall') {
          this.hasWallBackDropBeenUsed = true;
        }

      },

      dndShopWall(dropResult) {
        const {
          addedIndex
        } = dropResult;
        if (addedIndex !== null) {
          this.hasShopWallBeenUsed = true;
        }
      },

      dndPencilDrop(dropResult) {
        const {
          addedIndex
        } = dropResult;
        if (addedIndex !== null) {
          this.hasPencilToolBeenUsed = true;
          this.animateScene1();
        }
      },

      dndBackDrop(dropResult) {
        const {
          addedIndex
        } = dropResult;
        if (addedIndex !== null) {
          this.hasBackDropBeenUsed = true;
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "style";

  .noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
  }

  .hide-tool {
    z-index: -1;
  }

  // body {
  //   overflow: hidden;
  // }

  .smooth-dnd-container {
    .animated {
      transform: none !important;
    }
  }

  .scene-shop-app {
    background: $yellow;
    margin: 0;
    padding: 0;

    &__nav {
      position: absolute;
      right: fluid(90px);
      bottom: fluid(-20px);
      width: fluid(160px);

      button {
        font-family: $cursive;
        text-transform: uppercase;
        cursor: pointer;
      }
    }

    &__padding {
      position: relative;
      padding: 0 0 #{(380/725)*100%};
    }

    &__stage {
      padding: fluid(16px);
      overflow: hidden;
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .page-area {
    width: 100%;
    position: relative;
    margin: auto;
  }

  .page {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    max-width: fluid(550px);
    max-height: fluid(251px);
    margin: auto;

    &__title {
      position: relative;
      font-family: $cursive;
      font-weight: 300;
      color: #820C0C;
      text-shadow: fluid(1px) fluid(1px) fluid(.5px) black;
      text-align: center;
      top: fluid(15px);
      left: 47.5%;
      margin-bottom: fluid(25px);
      font-size: fluid(38px);
      width: 60%;
      word-spacing: fluid(5px);
    }

    &__sub_title {
      text-align: center;
      width: 100%;
      text-transform: uppercase;
      color: #000;
      font-size: fluid(17px);
      margin: 0;
      padding-bottom: fluid(5px);
    }

    &__instructions {
      position: relative;
      flex: 0 0 auto;
      padding: fluid(0px) fluid(3px);
      text-align: left;
      color: #000;
      font-size: fluid(15px);
      line-height: fluid(2px);
      margin-bottom: fluid(35px);
      word-wrap: none;
      width: fluid(287px);
      // left: fluid(-20px);

      #intro {
        position: relative;
        margin: fluid(8px) auto;
        padding: fluid(20px) fluid(0px);
        left: fluid(-90px);
      }

      #flats {
        position: relative;
        left: fluid(-20px);
      }
    }

    &__instructions_sketch {
      position: relative;
      flex: 0 0 auto;
      padding: fluid(0px) fluid(3px);
      text-align: left;
      color: #000;
      font-size: fluid(15px);
      line-height: fluid(2px);
      margin-bottom: fluid(100px);
      word-wrap: none;
      width: fluid(287px);
      left: fluid(70px);
    }

    &__instructions_scale {
      position: relative;
      flex: 0 0 auto;
      padding: fluid(0px) fluid(3px);
      text-align: left;
      color: #000;
      font-size: fluid(15px);
      line-height: fluid(2px);
      margin-bottom: fluid(35px);
      word-wrap: none;
      width: fluid(287px);
      left: fluid(70px);
    }

    &__instructions_flats {
      position: relative;
      flex: 0 0 auto;
      padding: fluid(0px) fluid(3px);
      text-align: left;
      color: #000;
      font-size: fluid(15px);
      line-height: fluid(2px);
      margin-bottom: fluid(35px);
      word-wrap: none;
      width: fluid(287px);
      left: fluid(-30px);
    }
  }

  .pencilDrop{
    position: absolute;
    top: fluid(-39px);
    left: fluid(-63px);
    height: fluid(230px);
  width: fluid(330px);
  background: red;
  z-index: 99;
  }

  .wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    width: fluid(243px);
    height: fluid(251px);
    z-index: 8;

    &__wire {
      height: 33.33%;
      width: 100%;
      z-index: 16;
      // background-color: #FF000099;
    }

    &__stand {
      height: 33.33%;
      width: 100%;
      // background-color: #00FF0099;
    }

    &__board {
      height: 33.33%;
      width: 100%;
      // background-color: #0000FF99;
    }
  }

  .s1wrap {
    position: absolute;
    display: flex;
    top: fluid(10px);
    left: fluid(-30px);
    flex-wrap: wrap;
    justify-content: space-between;
    // width: fluid(243px);
    height: fluid(251px);
    z-index: 10;

    .smooth-dnd-container {
      // position: absolute;
      // top: fluid(65px);
      // left: fluid(5px);
      width: fluid(400px);
      height: 100%;
      // background: blue;
    }
  }

  .s2wrap {
    // background: yellow;
    display: flex;
    // top: fluid(0px);
    left: fluid(63px);
    flex-wrap: wrap;
    justify-content: space-between;
    width: fluid(243px);
    height: fluid(251px);
    // z-index: 10;

    .smooth-dnd-container {
      // position: absolute;
      // top: fluid(65px);
      // left: fluid(5px);
      width: fluid(243px);
      height: 100%;
      // background: blue;
    }
  }

  #top {
    position: relative;
    height: 100%;
  }

  .s4wrap {
    display: flex;
    position: absolute;
    top: fluid(125px);
    left: fluid(120px);
    flex-wrap: wrap;
    justify-content: space-between;
    width: fluid(0px);
    height: fluid(0px);
    opacity: 1;
    z-index: 7;
    background: #00ff0099;

    .smooth-dnd-container {
      position: relative;
      top: fluid(-90px);
      left: fluid(-105px);
      height: fluid(190px);
      width: fluid(330px);
      z-index: 10;
    }
  }

  .item {
    width: 100%;
    height: 100%;
    margin: auto;
  }

  .item:nth-child(2n) {
    width: 100%;
    height: 50%;
    // background-color: #00ff0099;
  }

  .item:nth-child(3n) {
    width: 100%;
    height: 28%;
    // background-color: #0000ff99;
  }

  .item:nth-child(4n) {
    width: 100%;
    height: 22%;
    // background-color: #ffff0099;
  }

  // .wrap3 {
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
  //   width: 75%;
  //   height: fluid(45px);
  //   margin: auto;
  //   // z-index: 23;
  // }

  // .item2 {
  //   width: 100%;
  //   height: 30%;
  //   // background-color: #ff000099;
  // }

  // .item2:nth-child(2n) {
  //   width: 33.3%;
  //   height: 100%;
  //   // background-color: #00ff0099;
  // }

  // .item2:nth-child(3n) {
  //   width: 33.3%;
  //   height: 100%;
  //   // background-color: #0000ff99;

  // }

  // .item2:nth-child(4n) {
  //   width: 33.3%;
  //   height: 100%;
  //   // background-color: #ffff0099;

  // }

  // .wrap4 {
  //   width: fluid(243px);
  //   height: fluid(251px);
  //   // background: #5b53cf99;
  // }

  .floor_plan {
    position: relative;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene0--floor_plan.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    height: fluid(245px);
    width: fluid(331px);
    top: fluid(-60px);
    left: fluid(-52px);
    // margin: auto;
  }

  .floor_plan2 {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene1--sketch0.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    width: fluid(331px);
    height: fluid(251px);
    top: fluid(2px);
    left: fluid(50px);
  }

  .smooth-dnd-container {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 10;
  }

  .show_wallBackDrop {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene2--lwall.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: fluid(100px);
    left: fluid(20px);
    width: fluid(225px);
    height: fluid(127px);
    z-index: 1;
  }

  .hide_wallBackDrop {
    display: none;
    z-index: 1;
  }

  .show_shop {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene2--lshop3.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: fluid(-130px);
    left: fluid(26px);
    width: fluid(200px);
    height: fluid(105px);
    // z-index: 8;
  }

  .hide_shop {
    display: none;
    z-index: 1;
  }

  .show_curtain2 {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene5--curtain.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: fluid(337px);
    height: fluid(307px);
    left: fluid(1px);
    top: fluid(-46px);
    z-index: 89;
  }

  .hide_curtain2 {
    display: none;
    z-index: 1;
  }

  .woman {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene2--l_woman.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(290px);
    height: fluid(274px);
    left: fluid(-60px);
    top: fluid(5px);
    z-index: 6;
  }

  .base {
    position: absolute;
    background-image: url('~@/assets/img/scene2--l_base.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    bottom: fluid(-10px);
    left: fluid(40px);
    width: fluid(280px);
    height: fluid(70px);
    z-index: 11;
  }

  .curtain {
    position: relative;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene3--curtain.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(335px);
    height: fluid(255px);
    left: fluid(-55px);
    top: fluid(-75px);
    z-index: 6;
  }

  .background1 {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene3--drop1.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(305px);
    height: fluid(180px);
    left: fluid(26px);
    top: fluid(0px);
    z-index: 5;
    transform: translateY(fluid(-180px));

    &.switch-1-active {
      @include animation;
      transform: translateY(fluid(43px));
    }
  }

  .background2 {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene3--drop2.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(305px);
    height: fluid(180px);
    left: fluid(30px);
    top: fluid(0px);
    z-index: 6;
    transform: translateY(fluid(-180px));

    &.switch-2-active {
      @include animation;
      transform: translateY(fluid(40px));
    }
  }

  .background3 {
    position: absolute;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene3--drop3.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(305px);
    height: fluid(180px);
    left: fluid(37px);
    top: fluid(0px);
    z-index: 6;
    transform: translateY(fluid(-180px));

    &.switch-3-active {
      @include animation;
      transform: translateY(fluid(38px));
    }
  }

  .curtain2 {
    position: relative;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene4--curtain.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(355px);
    height: fluid(205px);
    left: fluid(-66px);
    top: fluid(-33px);
    z-index: 6;
  }

  .curtain3 {
    position: relative;
    flex: 0 0 auto;
    background: url('~@/assets/img/scene5--curtain.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: fluid(333px);
    height: fluid(285px);
    left: fluid(-55px);
    top: fluid(-77px);
    z-index: 6;
  }

  .tool-box-scene2 {
    position: relative;
    top: fluid(171px);
    left: fluid(226px);
    height: fluid(60px);
    // display: flex;
    // flex-wrap: wrap;
    justify-content: space-between;
    width: fluid(70px);
    // background: red;

    
    &__area-twin {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 90%;
      margin: auto;

      &__left {
        position: relative;
        width: 100%;
        height: fluid(60px);
        margin: auto;
      }
    }
  }
 
  .tool-box-scene5-props {
    position: relative;
    top: fluid(10px);
    height: fluid(100px);
    display: flex;
    width: 100%;
    // margin: auto;

    &__area {
      // position: absolute;
      display: flex;
      margin: 0 auto;
      height: fluid(100px);
      width: 100%;
      align-items: space-between;
      // background: #ff000099;
    }
  }

  .toolbox {
    height: fluid(60px);
    display: flex;
    // justify-content: space-between;
    z-index: 11;

    &__area {
      position: relative;
      width: auto;
      width: fluid(290px);
      height: fluid(60px);
      z-index: 99;
    }

    &__items {
      display: inline-block;
      margin: fluid(0px) fluid(2px);
      z-index: 99;
      position: absolute;

      &--wall {
        top: 0;
        left: 0;
      }

      &--shop-wall {
        top: 0;
        left: fluid(60px);
      }

      &--table {
        top: fluid(17px);
        left: fluid(196px);
      }

      &--chair {
        top: fluid(17px);
        left: fluid(243px);
      }
    }

    &--no-flex {
      display: block;
    }
  }

  .tool-box-scene4 {
    position: relative;
    top: fluid(10px);
    left: fluid(-340px);
    height: fluid(90px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 50%;
    margin: auto;

    &__area-twin {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      margin: auto;

      &__left {
        position: relative;
        width: 100%;
        height: fluid(60px);
        margin: auto;

        .smooth-dnd-container {
          position: relative;
          top: fluid(-10px);
          left: fluid(5px);
          width: 50%;
          height: fluid(150px);
          z-index: 7;
        }

        .vertical {
          position: relative;
          width: fluid(150px);
          height: fluid(50px);
        }
      }
    }
  }

  .tool-box {
    width: fluid(300px);
    height: fluid(100px);
    top: fluid(-30px);
    right: fluid(375px);
    margin: 0 auto;
    border-radius: fluid(14px);
    display: flex;
    flex-flow: row wrap;
    position: relative;
    // background: #ff000099;
    // z-index: 99;

    &__area {
      display: flex;
      position: absolute;
      flex-flow: row wrap;
      justify-content: space-around;
      margin: 0 auto;
      top: 5%;
      width: 100%;

      &__left {
        width: 50%;
        height: 100%;
        font-family: $cursive;
        text-align: center;

        .base_text {
          position: relative;
          width: 100px;
          left: fluid(-10px);
          padding: 0% 50%;
          font-size: fluid(16px);
          text-transform: lowercase;
          line-height: fluid(14px);
        }
      }

      &__right {
        width: 50%;
        height: 100%;
        color: white;
        font-family: $cursive;
        text-align: center;

        .base_text {
          position: relative;
          left: fluid(-10px);
          padding: 0% 50%;

          font-size: fluid(16px);
          text-transform: lowercase;
          line-height: fluid(14px);
        }
      }
    }

    &__area-single {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      &__left-single {
        width: 50%;
        margin: auto;

        .text-single {
          font-family: $cursive;
          width: 100%;
          padding: fluid(0px) fluid(0px);
          text-align: center;
          font-size: fluid(18px);
          line-height: fluid(24px);
          margin-left: fluid(0px);
          text-transform: uppercase;
        }
      }

      &__right-single {
        width: 50%;
      }
    }

    &__area-double {
      display: flex;
      flex-direction: row;
      width: 80%;
      margin: 0 auto;

      &.switch-1-active {
        .tool-box__area-double__left-double.switch1 {
          @include animation;
          transform: translateY(fluid(43px));
          cursor: default;
        }
      }

      &.switch-2-active {
        .tool-box__area-double__middle-double.switch2 {
          @include animation;
          transform: translateY(fluid(43px));
        }
      }

      &.switch-3-active {
        .tool-box__area-double__right-double.switch3 {
          @include animation;
          transform: translateY(fluid(43px));
        }
      }


      &__left-double {
        background-image: url('~@/assets/img/scene3--switchbox.svg');
        @include image;
        width: 33%;
        height: 70%;

        &.switch1 {
          position: relative;
          cursor: pointer;
          background-image: url('~@/assets/img/scene3--switchbox_switch.svg');
          @include image;
          transform: translateY(fluid(16px));
          left: fluid(28px);
          height: fluid(10px);
          opacity: 1;
        }
      }

      &__middle-double {
        background-image: url('~@/assets/img/scene3--switchbox.svg');
        @include image;
        margin: 0% 0%;
        width: 33%;
        height: 70%;

        &.switch2 {
          position: relative;
          // cursor: pointer;
          background-image: url('~@/assets/img/scene3--switchbox_switch.svg');
          @include image;
          transform: translateY(fluid(16px));
          left: fluid(28px);
          height: fluid(10px);
          opacity: 1;
        }
      }

      &__right-double {
        background-image: url('~@/assets/img/scene3--switchbox.svg');
        @include image;
        margin: 0% 0%;
        width: 33%;
        height: 70%;

        &.switch3 {
          position: relative;
          background-image: url('~@/assets/img/scene3--switchbox_switch.svg');
          @include image;
          transform: translateY(fluid(16px));
          left: fluid(28px);
          height: fluid(10px);
          opacity: 1;
        }
      }
    }
  }

  .tool-box-scene5 {
    position: absolute;
    width: fluid(330px);
    height: fluid(95px);
    top: fluid(240px);
    left: fluid(20px);
    border-radius: fluid(14px);
    display: flex;
    flex-flow: row wrap;
    z-index: 99;

    &__area {
      display: flex;
      position: absolute;
      flex-flow: row wrap;
      justify-content: space-around;
      margin: auto;
      top: 5%;
      width: 100%;

      &__left {
        width: 50%;
        height: 100%;
        margin: auto;
        font-family: $cursive;
        text-align: center;
      }

      &__right {
        width: 50%;
        height: 100%;
        margin: auto;
        color: white;
        font-family: $cursive;
        text-align: center;
      }
    }

    &__area-single {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      &__left-single {
        width: 50%;
        margin: auto;

        .text-single {
          font-family: $cursive;
          width: 100%;
          padding: fluid(0px) fluid(0px);
          text-align: center;
          color: #fff;
          font-size: fluid(14px);
          line-height: fluid(14px);
          margin-left: fluid(0px);
          text-transform: uppercase;
        }
      }

      &__right-single {
        width: 50%;
      }
    }

    &__area-double {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      &__left-double {
        margin: auto;
        padding-left: 10px;
        width: 50%;
        height: 70%;
      }

      &__middle-double {
        margin: auto;
        width: 25%;
        height: 70%;
      }

      &__right-double {
        margin: auto;
        width: 25%;
        height: 70%;
      }
    }
  }

  .tool-box-scene1 {
    position: relative;
    top: fluid(10px);
    left: fluid(-340px);
    height: fluid(90px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 50%;
    margin: auto;

    &__area-twin {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      margin: auto;

      &__left {
        position: relative;
        width: 100%;
        height: fluid(60px);
        margin: auto;

        .smooth-dnd-container {
          position: relative;
          top: fluid(-10px);
          left: fluid(5px);
          width: 50%;
          height: fluid(150px);
          z-index: 7;
        }

        .vertical {
          position: relative;
          width: fluid(150px);
          height: fluid(50px);
        }
      }
    }
  }

  .pencil {
      position: relative;
      background-image: url('~@/assets/img/tool_pencil.svg');
      width: fluid(50px);
      height: fluid(50px);
      top: fluid(0px);
      left: fluid(10px);
      @include image;
      z-index: 99;
      // background: red;
    }

  .tool {
    background-repeat: no-repeat;
    background-size: contain;

    &.hover {
      &+.hover_bg {
        position: absolute;
        display: flex;
        background: #FAE47699;
        background-image: url('~@/assets/img/scene5--hover.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        top: fluid(-210px);
        right: fluid(-350px);
        width: 100%;
        height: fluid(200px);
        z-index: 99;
      }
    }

    &.clicked {
      &+.tool__text {
        display: block;
        text-align: center;
        width: 85%;
        height: fluid(14px);
        font-size: fluid(10px);
        line-height: fluid(14px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        margin: fluid(7px) fluid(0px);
        left: fluid(-60px);
        z-index: 99;
      }

      &+.tool__text-backdrop {
        position: absolute;
        display: block;
        text-align: center;
        width: fluid(100px);
        height: fluid(15px);
        line-height: fluid(15px);
        margin: fluid(3px) auto;
        // padding: fluid(0px) fluid(10px);
        font-size: fluid(10px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        left: fluid(-25px);
        z-index: 99;
      }

      &+.tool__text-backdrop2 {
        position: absolute;
        display: block;
        text-align: center;
        width: fluid(100px);
        height: fluid(15px);
        line-height: fluid(15px);
        margin: fluid(3px) auto;
        // padding: fluid(0px) fluid(10px);
        font-size: fluid(10px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        top: fluid(50px);
        left: fluid(5px);
        z-index: 99;
      }

      &+.tool__text-walls {
        position: absolute;
        display: block;
        text-align: center;
        width: fluid(100px);
        height: fluid(15px);
        line-height: fluid(15px);
        margin: fluid(3px) auto;
        // padding: fluid(0px) fluid(10px);
        font-size: fluid(10px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        left: fluid(13px);
        z-index: 99;
      }

      &+.tool__text-table {
        position: absolute;
        display: block;
        text-align: center;
        width: auto;
        height: fluid(15px);
        line-height: fluid(15px);
        margin: fluid(3px) auto;
        padding: fluid(0px) fluid(10px);
        font-size: fluid(10px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        left: fluid(-5px);
        z-index: 99;
      }

      &+.tool__text-chair {
        position: absolute;
        display: block;
        text-align: center;
        width: auto;
        height: fluid(15px);
        line-height: fluid(15px);
        margin: fluid(3px) auto;
        padding: fluid(0px) fluid(10px);
        font-size: fluid(10px);
        font-weight: 800;
        background: #FFFFCC;
        border: 1px solid #000;
        left: fluid(-13px);
        z-index: 99;
      }
    }

    &__text {
      display: none;
    }

    &__text-backdrop,
    &__text-backdrop2,
    &__text-walls,
    &__text-table,
    &__text-chair {
      display: none;
    }

    &--combo {
      display: flex;
    }

    &--wall_backdrop {
      position: relative;
      cursor: pointer;
      background-image: url('~@/assets/img/scene2--wall_backdrop.svg');
      height: fluid(50px);
      width: fluid(50px);
      z-index: 9;
    }

    &--shop_walls {
      position: relative;
      cursor: pointer;
      background-image: url('~@/assets/img/scene2--shop_walls.svg');
      width: fluid(128px);
      height: fluid(52px);
      z-index: 19;
    }

    &--table {
      position: relative;
      cursor: pointer;
      background-image: url('~@/assets/img/scene2--table.svg');
      width: fluid(39px);
      height: fluid(35px);
      // top: fluid(5px);
      z-index: 99;
    }

    &--chair {
      position: relative;
      cursor: pointer;
      background-image: url('~@/assets/img/scene2--chair.svg');
      width: fluid(19px);
      height: fluid(35px);
      // top: fluid(5px);
      z-index: 99;
    }

    &--test {
      width: fluid(25px);
      height: fluid(25px);
    }

    &--pencil {
      position: absolute;
      background-image: url('~@/assets/img/tool_pencil.svg');
      width: fluid(50px);
      height: fluid(50px);
      top: fluid(-9px);
      left: fluid(40px);
      @include image;
      z-index: 99;
      // background: red;
    }

    &--backdrop {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene4--backdrop.svg');
      height: fluid(70px);
      width: fluid(140px);
      top: fluid(-20px);
      left: fluid(-15px);
      z-index: 2;
    }

    &--curtain_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--curtain_c.svg');
      width: fluid(40px);
      height: fluid(75px);
      top: fluid(15px);
      left: fluid(2px);
      z-index: 24;
    }

    &--woman_c {
      position: relative;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--woman_c.svg');
      width: fluid(35px);
      height: fluid(69px);
      top: fluid(25px);
      left: fluid(37px);
      z-index: 30;
    }

    &--shelf_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--shelf_c.svg');
      width: fluid(45px);
      height: fluid(27px);
      top: fluid(-4px);
      left: fluid(67px);
      z-index: 25;
    }

    &--wig_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--wig_c.svg');
      width: fluid(50px);
      height: fluid(29px);
      top: fluid(32px);
      left: fluid(75px);
      z-index: 28;
    }

    &--table_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--table_c.svg');
      width: fluid(42px);
      height: fluid(40px);
      top: fluid(62px);
      left: fluid(78px);
      z-index: 22;
    }

    &--wallcurtains_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--wallcurtains_c.svg');
      width: fluid(28px);
      height: fluid(59px);
      top: fluid(5px);
      left: fluid(132px);
      z-index: 27;
    }

    &--chair_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--chair_c.svg');
      height: fluid(50px);
      width: fluid(50px);
      top: fluid(47px);
      left: fluid(155px);
      z-index: 29;
    }

    &--dress_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--dress_c.svg');
      width: fluid(27px);
      height: fluid(65px);
      top: fluid(40px);
      left: fluid(187px);
      z-index: 26;
    }

    &--man_c {
      position: absolute;
      cursor: pointer;
      background-image: url('~@/assets/img/scene5--man_c.svg');
      width: fluid(27px);
      height: fluid(65px);
      top: fluid(34px);
      left: fluid(220px);
      z-index: 23;
    }

    &--stage_button {
      cursor: pointer;
      position: relative;
      margin: auto;
      background-image: url("~@/assets/img/button_back.svg");
      background-position: top center;
      width: fluid(136px);
      height: fluid(37px);
      top: fluid(30px);
      z-index: 1;
    }

    &--view_sketch {
      position: relative;
      margin: auto;
      background-image: url("~@/assets/img/view_sketch.svg");
      width: fluid(136px);
      height: fluid(37px);
      top: fluid(30px);
      z-index: 1;
    }

    .ui-paper {
      flex: 0 0 auto;
      background: #fff;
      width: fluid(256px);
      height: fluid(251px);
      box-shadow: fluid(-4px) fluid(4px) 0 #000;
    }
  }

  .draggable {
    width: auto !important;
    height: auto !important;
  }

  .i-btn {
    appearance: none;
    border: 0;
    background: transparent;
    // font-weight: 600;
    margin: auto;
    font-size: fluid(18px);
    flex: 0 0 auto;

    &:before {
      content: '';
      width: fluid(33px);
      height: fluid(33px);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      display: block;
      margin: 0 auto;
    }

    &--back {
      float: left;
      justify-self: start;

      &:before {
        background-image: url('~@/assets/img/button_arrow_l.svg');
      }
    }

    &--next {
      float: right;

      &:before {
        background-image: url('~@/assets/img/button_arrow_r.svg');
      }
    }
  }
</style>